import { MDBBtn, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCardTitle, MDBCol } from 'mdbreact'
import React from 'react'
import { NumericFormat } from 'react-number-format'
import Botones from './Botones'
import { useValidarImagen } from '../../../hooks/useValidarImagen'

const Tarjeta1 = (props) => {
    const { urlImg, tituloCard, textoCard } = props?.styles

    return (
        <MDBCol className='card-tarjeta-1'>
            <MDBCard style={{ width: "20rem" }}>
                <img className="img-fluid image-card" src={useValidarImagen(urlImg)} />
                <MDBCardBody>
                    <MDBCardTitle>{tituloCard}</MDBCardTitle>
                    <MDBCardText>
                        {textoCard}
                    </MDBCardText>
                    <Botones {...props} />
                </MDBCardBody>
            </MDBCard>
        </MDBCol>
    )
}

export default Tarjeta1